import { currentCountry, app } from '@/utils/starters';
import {
  GT, SV, HN, NI, CR, MCA
} from '@/utils/constants';
import { MPC as atlasMPC, legacyMPC } from './MPC';
import { legacyMCW, MCW as atlasMCW } from './MCW';
import { legacyChatbot } from './Chatbot';

const countriesWithAtlas = [GT, SV, HN, NI, CR];
const MCW = countriesWithAtlas.includes(currentCountry) ? atlasMCW : legacyMCW;

const isMCA = MCA === app;
const MPC = isMCA ? atlasMPC : legacyMPC;

const Maintenance = {
  path: '/maintenance',
  name: 'maintenance',
  component: () => import('@/views/common/Components/Maintenance')
};

const Error404 = {
  path: '*',
  name: 'Error404',
  component: () => import('@/views/common/ErrorView'),
  props: { defaultError: '404' }
};

const routes = [
  MPC,
  legacyChatbot,
  MCW,
  Maintenance,
  Error404
];

export default routes;
